/**
 * @file index.tsx
 *
 * @fileoverview Generates a component that displays information on the middle of the page.
 */

import styles from "../Alignment.module.scss";

/**
 * Generates a component that displays information
 * on the middle of the page.
 */
export default function CenterBox({ children }) {
  return <div className={styles.centerBox}>{children}</div>;
}
export { CenterBox };
